import { render, staticRenderFns } from "./BackEnd.vue?vue&type=template&id=6fb5fde8"
import script from "./BackEnd.vue?vue&type=script&lang=js"
export * from "./BackEnd.vue?vue&type=script&lang=js"
import style0 from "./BackEnd.vue?vue&type=style&index=0&id=6fb5fde8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports